import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Alert from '@mui/material/Alert'
import { getHealth } from '../services/authApi'

interface ConnectDialogProps {
  onConnect: () => void
}

export function ConnectDialog({ onConnect }: ConnectDialogProps) {
  const [url, setUrl] = useState(localStorage.getItem('authServiceUrl') || 'https://auth-service.rohan-270.workers.dev')
  const [key, setKey] = useState(localStorage.getItem('authServiceKey') || '')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleConnect() {
    setError('')
    setLoading(true)

    localStorage.setItem('authServiceUrl', url)
    localStorage.setItem('authServiceKey', key)

    try {
      await getHealth()
      onConnect()
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to connect')
      localStorage.removeItem('authServiceKey')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      bgcolor: 'background.default',
      p: 3,
    }}>
      <Paper sx={{ p: 4, maxWidth: 480, width: '100%', border: '1px solid', borderColor: 'divider' }}>
        <Typography variant="h3" sx={{ mb: 1 }}>Auth Admin</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Connect to the Rival authorization service to manage organizations, roles, and policies.
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <TextField
          fullWidth
          label="Auth Service URL"
          value={url}
          onChange={e => setUrl(e.target.value)}
          placeholder="https://auth-service.rohan-270.workers.dev"
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="Service API Key"
          type="password"
          value={key}
          onChange={e => setKey(e.target.value)}
          placeholder="X-Service-Key value"
          sx={{ mb: 3 }}
        />

        <Button
          fullWidth
          variant="contained"
          onClick={handleConnect}
          disabled={loading || !url || !key}
        >
          {loading ? 'Connecting...' : 'Connect'}
        </Button>
      </Paper>
    </Box>
  )
}
